import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import NewsletterManager from "../NewsletterManager";
import NewsletterCampaigns from "./NewsletterCampaigns";
import NewsletterTemplates from "./NewsletterTemplates";

const NewsletterSection: React.FC = () => {
  const [tab, setTab] = useState(0);

  return (
    <div>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
        <Tabs
          value={tab}
          onChange={(_e, value) => setTab(value)}
          aria-label="newsletter-tabs"
        >
          <Tab
            label="Subscritores"
            id="tab-newsletter-subscribers"
            aria-controls="panel-newsletter-subscribers"
          />
          <Tab
            label="Campanhas"
            id="tab-newsletter-campaigns"
            aria-controls="panel-newsletter-campaigns"
          />
          <Tab
            label="Templates"
            id="tab-newsletter-templates"
            aria-controls="panel-newsletter-templates"
          />
        </Tabs>
      </Box>
      <div
        role="tabpanel"
        id="panel-newsletter-subscribers"
        aria-labelledby="tab-newsletter-subscribers"
        hidden={tab !== 0}
      >
        {tab === 0 && <NewsletterManager />}
      </div>
      <div
        role="tabpanel"
        id="panel-newsletter-campaigns"
        aria-labelledby="tab-newsletter-campaigns"
        hidden={tab !== 1}
      >
        {tab === 1 && <NewsletterCampaigns />}
      </div>
      <div
        role="tabpanel"
        id="panel-newsletter-templates"
        aria-labelledby="tab-newsletter-templates"
        hidden={tab !== 2}
      >
        {tab === 2 && <NewsletterTemplates />}
      </div>
    </div>
  );
};

export default NewsletterSection;
